<style>
.no-padding-modal .ivu-modal-body {
  padding: 0;
}
.frm-main-contact .el-form-item__label {
  margin-bottom: 0;
  line-height: 1.5;
}
.frm-main-contact .el-input__inner {
  height: 30px;
}
</style>

<template>
  <div :class="`${fromHome ? 'mg-b-20' : ''}`">
    <div class="bd-b pd-b-5 pd-t-10 mg-b-10">
      <div class="d-flex align-items-center justify-content-between">
      
        <span class="mg-b-0 tx-14">Сургалт, Шалгалтын цахим бүртгэл</span>
        <!-- <button
          class="btn btn-xs btn-primary text-white pd-y-2 pd-x-5 btn-uppercase mg-l-auto"
          @click="examPointModal = true"
        >
          дүн харах
        </button> -->
      </div>
    </div>
    <div class="p-xxs mg-b-10 alert alert-secondary" v-for="(f, i) in fileDownloads" :key="i">
      <a
        role="button"
        style="color: #0168fa"
        @click="downloadAttachment(f.value)"
        >{{ f.name }}</a
      >
    </div>
    <div class="overflow-auto" :style="`max-height: ${fromHome ? 'inherit' : 'calc(100vh - 270px);'}`">
      <div :class="`d-flex ${fromHome ? 'flex-col' : 'flex-row'} mg-b-20 m-t-sm`" v-if="list.length > 0">
        <template v-for="(row, i) in list">
          <div :class="`bd rounded mg-${fromHome ? 'b' : 'r'}-10`" :key="i">
            <div class="media align-items-center pd-10">
              <div class="media-body">
                <p class="tx-13 tx-semibold mg-b-0">{{ row.task }}</p>
                <p class="tx-12 mg-b-0 tx-color-03">
                  {{ row.d2 | moment("YYYY/MM/DD") }} - {{ row.dueStartDate | moment("YYYY/MM/DD") }}
                </p>
              </div>
              
            </div>
            <div class="pd-x-10 pd-b-5">
              <span class="tx-12  bd-l pd-l-5">{{ row.locTypeName }}</span>
              
              <div>
                <div :class="`badge badge-${row.locType1Code==='exam'?'success':'primary'} tx-uppercase`">{{ row.locType1Name }}</div>
              </div>
            </div>
            <div class="bd-t pd-5 bg-gray-50 d-flex align-items-center justify-content-between">
              <div class="mg-r-10">{{ row.budget | formatMoney(2, ".", ",") }}₮</div>
              <div class="text-right tx-rubik">
                <button
                  @click="sendRequestBefore(row)"
                  class="btn btn-xs btn-uppercase btn-primary flex-fill tx-spacing-1"
                >
                  хүсэлт илгээх
                </button>
              </div>
            </div>
          </div>
        </template>
      </div>
      <!-- <div v-else-if="examRs.filter(x=>x.id==$route.params.id).length > 0" class="alert alert-warning">
        <b>{{ examRs.filter(x=>x.id==$route.params.id)[0]['s1'] }}</b> -д одоогоор цахим бүртгэл зарлагдаагүй байна.
      </div> -->
      <div class="card m-b-sm" v-if="invoices.length > 0">
        <div class="card-header pd-y-15 pd-x-20">Миний илгээсэн хүсэлтүүд</div>
        <div class="card-body pd-0">
          <ul class="list-group list-group-flush tx-13">
            <li
              role="button"
              @click="fromExisting = true; continueExamRegistration(inv, i)"
              :key="i"
              v-for="(inv, i) in invoices"
              class="list-group-item pd-0"
            >
              <div class="d-flex pd-10">
                <div class="avatar d-none d-sm-block" style="min-width: 30px;">
                  <span
                    class="avatar-initial rounded-circle"
                    :style="
                      `min-width: 40px; background-color: ${displayStatus(
                        inv,
                        1
                      )}`
                    "
                  >
                    {{ i + 1 }}
                  </span>
                </div>
                <div class="pd-sm-l-20">
                  <p class="tx-medium mg-b-0">
                    {{ inv.thirdOrganizationTask.task }}
                  </p>
                  <small class="tx-12 tx-color-03 mg-b-0">{{
                    inv.createdDate | moment("YYYY/MM/DD")
                  }}</small>
                </div>
                <div class="mg-l-auto text-right">
                  <p class="tx-medium mg-b-0">
                    <template v-if="inv.isTender == false">
                      <a
                        v-if="
                          inv.budget > 0 &&
                            $store.state.user.userInfo.groupId != 6126
                        "
                        @click="$emit('on-show-payment', inv.id)"
                        class="tx-12 mg-b-0 tx-danger"
                        >{{ inv.budget | formatMoney(2, ".", ",") }}₮</a
                      >
                    </template>
                    <template v-else>
                      <template
                        v-if="inv.thirdOrganizationTask.objectTypeId == 340"
                        >{{ inv.budget | formatMoney(2, ".", ",") }}₮</template
                      >
                      <p v-else class="tx-12 mg-b-0 tx-success">
                        {{ inv.budget | formatMoney(2, ".", ",") }}₮ төлсөн
                      </p>
                    </template>
                  </p>
                </div>
              </div>
              <div class=" d-flex bg-gray-50 pd-10 align-items-center">
                <exam-invoice-accept
                  ref="btnLearnExamInvoiceAccept"
                  :taskId="inv.id"
                  :task="inv"
                  btnTxt="хэвлэх"
                  class="m-rxs"
                >
                  <button v-if="1==2"
                    slot="btn"
                    @click.stop="showPrint(i)"
                    type="button"
                    class="btn btn-xs btn-primary m-r-md"
                  >
                    <span>хэвлэх</span>
                  </button>
                </exam-invoice-accept>
                <div class="mg-l-auto">
                  Төлөв:
                  <span :style="`color: ${displayStatus(inv, 1)}`">{{
                    displayStatus(inv, 0)
                  }}</span>
                </div>
              </div>
            </li>
          </ul>
        </div>
      </div>
      <div v-else-if="!fromHome" class="alert alert-warning">Илгээсэн хүсэлт байхгүй байна.</div>
    </div>

    <b-modal
      :transition-names="[]"
      class="no-padding-modal"
      v-model="examPointModal"
      :mask-closable="true"
      title="Шалгалт"
      hide-footer
      size="lg"
    >
      <exam-point v-if="examPointModal"></exam-point>
    </b-modal>

    <b-modal
      :transition-names="[]"
      class="no-padding-modal"
      v-model="showModal"
      :mask-closable="false"
      title="Сургалт, Шалгалтын цахим бүртгэл"
      @on-ok="SubmitRequest"
      :ok-text="step == 1 ? 'Дараах' : 'Илгээх'"
      @on-cancel="hideModal"
      footer-hide
      width="50vw"
      size="xl"
      hide-footer
      scrollable
    >
      <div class="p-sm">
        <Steps :active="step - 1" size="small" simple>
          <Step title="Профайл" icon="el-icon-check"></Step>
          <Step title="Хүсэлт" icon="el-icon-edit"></Step>
          <Step title="Материал" icon="el-icon-bank-card"></Step>
          <Step title="Төлбөр" icon="el-icon-bank-card"></Step>
        </Steps>
      </div>
      <Divider>{{ task.task }} <span class="tx-color-03">({{ task.locTypeName }})</span></Divider>
      <div class="text-center">{{ courseDetail.s2 }}</div>
      <div v-show="step == 1">
        <div class="card mg-b-20 mg-lg-b-25 mainProfileBox">
          <div class="card-header pd-y-15 pd-x-20 d-flex align-items-center justify-content-between">
            <h6 class="tx-uppercase tx-semibold mg-b-0"> 1. Ерөнхий мэдээлэл </h6>
          </div>
          <div class="card-body">
            <div class="d-flex">
              <div class="bd rounded pd-x-15" style="width: 75%;">
                <div class="row no-gutters mg-t-0-f">
                  <div class="col-md-6">
                    <div class="form-group row mg-b-0 mg-t-0-f bd-b">
                      <div class="col-sm-5 bg-gray-100 pd-10 bd-r">
                        <label class="tx-13 tx-medium mg-b-0 text-muted">Ургийн овог</label>
                      </div>
                      <div class="col-sm-7 pd-10">
                        <span class="tx-13">{{ profile.st2 }}</span>
                      </div>
                    </div>
                    <div class="form-group row mg-b-0 mg-t-0-f bd-b">
                      <div class="col-sm-5 bg-gray-100 pd-10 bd-r">
                        <label class="tx-13 tx-medium mg-b-0 text-muted">Эцэг /эх/-ийн нэр</label>
                      </div>
                      <div class="col-sm-7 pd-10">
                        <span class="tx-13">{{ profile.lat }}</span>
                      </div>
                    </div>
                    <div class="form-group row mg-b-0 mg-t-0-f bd-b">
                      <div class="col-sm-5 bg-gray-100 pd-10 bd-r">
                        <label class="tx-13 tx-medium mg-b-0 text-muted">Нэр</label>
                      </div>
                      <div class="col-sm-7 pd-10">
                        <span class="tx-13">{{ profile.task }}</span>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group row mg-b-0 mg-t-0-f bd-b">
                      <div class="col-sm-5 bg-gray-100 pd-10 bd-r">
                        <label class="tx-13 tx-medium mg-b-0 text-muted">Регистрийн дугаар</label>
                      </div>
                      <div class="col-sm-7 pd-10">
                        <span class="tx-13">{{ profile.langCode }}</span>
                      </div>
                    </div>
                    <div class="form-group row mg-b-0 mg-t-0-f bd-b">
                      <div class="col-sm-5 bg-gray-100 pd-10 bd-r">
                        <label class="tx-13 tx-medium mg-b-0 text-muted">Төрсөн он сар өдөр</label>
                      </div>
                      <div class="col-sm-7 pd-10">
                        <span class="tx-13">{{ profile.d1 | moment('YYYY.MM.DD') }}</span>
                      </div>
                    </div>
                    <div class="form-group row mg-b-0 mg-t-0-f bd-b">
                      <div class="col-sm-5 bg-gray-100 pd-10 bd-r">
                        <label class="tx-13 tx-medium mg-b-0 text-muted">Хүйс:</label>
                      </div>
                      <div class="col-sm-7 pd-10">
                        <span class="tx-13">{{ profile.locType1Name }}</span>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-12">
                    <div class="form-group row mg-b-0 mg-t-0-f">
                      <div class="col-sm-3  pd-10 bd-r">
                        <label class="tx-13 tx-medium mg-b-0 text-muted">Хаяг</label>
                      </div>
                      <div class="col-sm-9 pd-10">
                        <span class="tx-13">{{ profile.address || '' }}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="pd-l-15" style="width: 35%;">
                <div class="bd rounded pd-10">
                  <Form class="frm-main-contact">
                    <FormItem label="Утасны дугаар" class="mg-b-5">
                      <Input v-model="profile.mobile" />
                    </FormItem>
                    <FormItem label="И-мэйл хаяг" class="mg-b-5">
                      <Input v-model="profile.taskEn" />
                    </FormItem>
                    <FormItem label="Яаралтай үед холбоо барих дугаар" class="mg-b-0">
                      <Input v-model="profile.st4" />
                    </FormItem>
                  </Form>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div  v-for="(b, i) in profile.b" :key="i">
              <div
                :class="`card mg-b-${b.ot == 140 ? '0' : '20'} mg-lg-b-${b.ot == 140 ? '0' : '25'} tourBox_${b.ot} ${getCls(b)}`"
              >
                <div
                  :class="
                    `card-header
                    pd-y-15 pd-x-20
                    d-flex
                    align-items-center
                    justify-content-between tourBox_hdr_${b.ot}`
                  "
                >
                  <h6 class="tx-uppercase tx-semibold mg-b-0">
                    {{ i + 2 }}. {{ b.nm }}
                     <!-- {{ b.ot }} -->
                  </h6>
                  <nav class="nav nav-with-icon tx-13 mg-l-20">
                    <a
                      @click="openAdd(b)"
                      :class="`nav-link tourBox_addBtn_${b.ot}`"
                      role="button"
                    >
                      <feather
                        type="plus"
                        class="mg-r-5 ht-20-f wd-20-f"
                      ></feather
                      >Нэмэх
                    </a>
                  </nav>
                </div>
                <!-- card-header -->
                <div class="card-body pd-0">
                  <loader
                    :ref="`ldr_box_${b.id}`"
                    :box="b"
                    :prms="{ boxChooser: false }"
                    :detailSettingProp="{
                      boxSetting: {
                        listSetting: { height: 0 },
                        hideToolbar: true,
                        hideEmptyTemplate: true,
                        autoHeight: true,
                      },
                    }"
                    @on-attach="onAttach"
                    @on-detail="showDetail"
                    @load-box="loadBoxData"
                    @box-loaded="boxLoaded"
                  />
                </div>
                <!-- card-footer -->
              </div>
              <div v-if="b.ot == 139" class="mg-b-20 mg-lg-b-25 mg-t-10">
                <Alert type="warning" show-icon title="Эзэмшсэн мэргэжил санамж" :closable="false">
                  <span class="ivu-alert-desc"
                    >Хүснэгтэд татагдсан мэдээллийг хянаж, дутуу болон буруу мэдээллийг шинэчлэн оруулна уу.</span>
                </Alert>
              </div>
              <div v-if="b.ot == 140" class="mg-b-20 mg-lg-b-25 mg-t-10">
                <Alert type="warning" show-icon title="Ажлын туршлагын санамж 1" :closable="false">
                  <span class="ivu-alert-desc"
                    >Газар зохион байгуулалт, геодези, зураг зүйн салбарын мэргэжилтэнд мэргэшлийн зэрэг олгоход тавигдах шаардлагын дагуу “Мэргэшсэн зэрэг” горилох мэргэжилтэн нь мэргэжлээрээ 5-аас доошгүй жил, “Зөвлөх зэрэг” горилох мэргэжилтэн нь мэргэжлээрээ 11-ээс доошгүй жил ажилласан мэдээллийг оруулна. </span>
                </Alert>

                <Alert type="warning" show-icon title="Ажлын туршлагын санамж 2" :closable="false" class="mg-t-10">
                  <span class="ivu-alert-desc">
                    Байгууллагын нэр дээр дарж, ‘Засах’ товчийг сонгон албан тушаалын нэр болон бусад шаардлагатай мэдээллийг бүрэн оруулж, засварлана уу.
                  </span>
                </Alert>
              </div>
            </div>

      </div>
     

      
      <template v-if="step == 2">

        <Form
          
          :model="submitModel"
          label-width="250"
          class="p-sm"
        >

          <FormItem label="Хүсэлт">
            <Input
              autofocus
              v-model="submitModel.task"
              placeholder="Хүсэлт..."
            />
          </FormItem>
          
          <FormItem label="Сургалт, Шалгалтын бүртгэлийн журамтай" class="d-flex align-items-center">
            <a @click="readGeree" role="button" class="tx-primary mg-t-0">энд дарж</a> танилцана уу.
          </FormItem>
          <FormItem label="Би дээрх мэдээлэл үнэн болохыг хүлээн зөвшөөрч байна.">
            <Checkbox v-model="submitModel.isRepeat"></Checkbox>
          </FormItem>
        </Form>
      </template>

      <div v-if="step == 3" class="p-sm">
        <Alert class="mg-b-10"
          type="warning"
          show-icon
          title="Анхааруулга"
          :closable="false"
          description="Бүрдүүлэх материал олон хуудастай бол PDF файл болгоод оруулна уу"
        ></Alert>

        <loader
          :ref="'direct_corebox_' + b.id"
          :key="i"
          v-for="(b, i) in reqDetail.b.filter((x) => x.ot == 440)"
          @box-loaded="materialTasksLoaded"
          :box="b"
          :prms="{ boxChooser: false }"
          :boxId="b.id"
          :objectTypeId="b.ot"
          :index="i + 1"
          :parentTask="reqDetail"
          :onMountedInitDisabled="false"
          :fromDetail="false"
          :scrollDisabled="true"
          :hideExtraButton="true"
          :hideAddButton="true"
          :detailSettingProp="{
            boxSetting: {
              autoHeight: true,
              hideToolbar: true,
              listSetting: { height: 150 },
            },
          }"
          :disableContextMenu="true"
          @on-attach="onAttach"
        />
        
      </div>
      <div v-if="step == 4" class="p-sm">
        <go-payment
          :key="gopymntKey"
          ref="gopymnt"
          :autoHeight="true"
          :invoiceId="reqDetail.id"
          :hideBackBtn="true"
          @on-payback="step = 4"
          @on-pay-success="
            reqDetail.id = 0;
            paymentVisible = false;
            init();
            initInvoices();
          "
        >
          <button
            @click.stop="step--"
            class="btn btn-warning btn-block"
          >
            Буцах
          </button>
        </go-payment>
      </div>
      <template v-if="courseDetail.s1 != null">
        <Alert
          v-if="courseDetail.s1 != ''"
          title="Анхааруулга"
          type="warning"
          show-icon
          >{{ courseDetail.s1 }}</Alert
        >
      </template>

      <div class="pd-md">

        <Alert v-if="step == 3" type="warning" show-icon title="Өмнө нь авсан мэргэшлийн зэргийн гэрчилгээний хуулбар" :closable="false" class="mg-b-10">
          <span class="ivu-alert-desc">
            Өмнө нь мэргэшлийн зэрэг авч байгаагүй, анх удаа зэрэг горилж буй тохиолдолд уг мэдээллийг заавал бөглөх шаардлагагүй.
          </span>
        </Alert>

        <Alert :type="step == 3 ? 'info' : 'warning'" show-icon title="Санамж" :closable="false">
          <span class="ivu-alert-desc" v-if="step == 1"
            >Бүртгэлийн мэдээллийг үнэн зөв бөглөхийг анхаарна уу.
            Худал мэдээлэл оруулсан тохиолдолд таны эрхийг цуцалж, сургалт болон шалгалтад оролцуулахгүй болно.</span>
          <span class="ivu-alert-desc tx-16" v-else-if="step == 2"
            >Бүртгэлийн журамтай танилцаад материал оруулах дарна уу</span
          >
          <span class="ivu-alert-desc" v-else-if="step == 3"
            >Бүрдүүлэх материалуудыг оруулна уу. Таны хүсэлтийг холбогдох мэргэжилтэн нягтлаад баталгаажсан төлөвт шилжсэний дараа төлбөр төлөх боломжтой.</span
          >
          <span class="ivu-alert-desc" v-else-if="step == 4">Төлбөр төлснөөр таны бүртгэл баталгаажна.</span
          >
        </Alert>

        
      </div>

      <div class="pd-5 pd-t-20 text-center">
        <ButtonGroup v-if="step == 4">
          <!-- <Button @click="step--">Буцах</Button>
          <Button @click="updateInvoiceInfo()" type="primary" class="tx-white">Дараах</Button> -->
        </ButtonGroup>
        <ButtonGroup v-else-if="step == 2">
          <Button @click="step--">Буцах</Button>
          <Button @click="SubmitRequest" type="primary" class="tx-white">Материал оруулах</Button>
        </ButtonGroup>
        <ButtonGroup v-else-if="step == 3">
        <!-- {{  }} -->
          <!-- <Button @click="backToProfile(reqDetail.thirdOrganizationTask)" type="">Профайл хэсэг рүү буцах </Button> -->
          <!-- <Button @click="materialCloseOne()" type="warning">Хаах</Button> -->
          <Button v-if="reqDetail?.i7==2" @click="reSendReq()" type="primary">Дахин илгээх</Button>
          <Button v-else-if="!fromExisting" @click="materialCloseOne()" type="primary">Хүсэлт илгээх</Button>
        </ButtonGroup>
        <ButtonGroup v-else-if="step != 5">
          <Button
            @click="hideModal"
            v-if="step < 3 || step == 4"
            type="error"
            >{{ step == 1 ? "Болих" : "Буцах" }}</Button
          >
          <Button @click="showModal = false" v-if="step == 3" type="warning"
            >Хаах</Button
          >
          <Button @click="SubmitRequest" type="primary">{{
            step == 3 ? "Илгээх" : "Дараах"
          }}</Button>
        </ButtonGroup>
      </div>

      <task-edit
        :prms.sync="taskEdit"
        :show.sync="taskEdit.show"
        :disablePreEditCheck="true"
        @on-task-posted="taskPosted"
        @on-edit-close="editClosed"
      ></task-edit>

      <task-detail-side
        v-if="taskDialogSide.id > 0"
        :id.sync="taskDialogSide.id"
        propWidth="50%"
        @on-task-detail="showDetail"
        @on-task-delete="taskDeleted"
        @on-task-reload="taskUpdated"
        @on-task-close="taskDialogSide.id = 0"
        :detailSettingProp="{
          hideMainMenu: true,
          showMiniMenu: true,
          hideExecution: true,
          hideProcess: true,
        }"
        :sideRight="false"
      ></task-detail-side>
    </b-modal>
    <b-modal
      v-model="modalGeree.show"
      hide-footer
      title="Файл"
      centered
      body-class="pd-0"
      size="xl"
      scrollable
    >
      <div class="modal-body pd-0">
        <file-preview
          :id="modalGeree.id"
          v-if="modalGeree.rdy"
          :force="true"
          :minusHeight="200"
        />
      </div>
    </b-modal>

    
  </div>
</template>
<script>
import { request } from "@/api/all";
import "element-ui/lib/theme-chalk/index.css";
import {
  Button,
  Steps,
  Step,
  Divider,
  Form,
  FormItem,
  Checkbox,
  ButtonGroup,
  Alert,
  Input,
  RadioGroup,
  Radio,
  Message,
  Notification,
} from "element-ui";

import { getConfigValueByKey } from "@/libs/util";

import AsyncLoadError from "@/components/base/asyncLoadingError";
import AsyncLoading from "@/components/base/asyncLoading";
import loader from "@/components/box/loader/loader.vue";
const moment = require("moment");


export default {
  components: {
    Button,
    Steps,
    Step,
    Divider,
    Form,
    FormItem,
    Checkbox,
    ButtonGroup,
    Alert,
    Input,
    RadioGroup,
    Radio,
    Message,
    locTypeCascader: () => ({
      component: import("@/components/task/edit/components/locTypeCascader"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
    examInvoiceAccept: () => ({
      component: import(
        "@/views/modules/lms/student/components/examInvoiceAccept"
      ),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 300,
      timeout: 20000,
    }),
    examPoint: () => ({
      component: import("@/views/modules/lms/student/components/examPointEgazar"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 300,
      timeout: 20000,
    }),
    loader,
    goPayment: () => ({
      component: import("@/components/modules/payment"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
    filePreview: () => ({
      component: import("@/components/modules/media/previewPage.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
    taskEdit: () => ({
      component: import("@/components/task/edit/base"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
    taskDetailSide: () => ({
      component: import("@/components/task/detail/dialog.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
  },
  name: "futureCourseList",
  props: {
    fromHome: {
      type: Boolean,
      default: () => true,
    },
    mode: {
      type: Number,
      default: () => null,
    },
  },
  data() {
    return {
      ilgeejbuibvrtgel: {},
      invoiceTask: {
        task:{
          i3: null,
          task: '',
          st2: '',
        }
      },
      reqDetail: {},
      stepCur: 0,
      examPointModal: false,
      fileDownloads: [],
      gopymntKey: 1,
      payInvoiceId: 0,
      paymentVisible: false,
      trueData: true,
      list: [],
      showModal: false,
      task: {},
      lessons: [],
      courseDetail: {},
      step: 1,
      stepPost: 2,
      submitModel: {},
      profileModel: {},
      ssList: [],

      invoices: [],
      materialFull: false,
      modalGeree: {
        show: false,
        rdy: false,
        id: 0,
      },
      lastExams: [],
      examRs: [],
      profile:{},
      taskEdit: {
        id: 0,
        boxId: 0,
        show: false,
        render: false,
        objectTypeId: 0,
        projectId: 0,
        parentId: 0,
      },
      taskDialogSide: {
        show: false,
        id: 0,
        boxId: 0,
        key: 0,
      },
      fromExisting: false,
    };
  },
  mounted() {
    // console.log('mounted', this.$route);
    this.init();
    this.fetchExamRs();
    this.initFiles();
    this.initInvoices();
  },
  watch: {
    // '$route.params.mode': {
    //   handler(newVal, oldVal) {
    //     console.log('newVal', newVal, oldVal);
    //     // if(newVal>0){
    //     //   this.init(newVal);
    //     // }
    //   },
    //   immediate: true
    // },
    '$route.params.id': {
      handler(newVal, oldVal) {
        // console.log('newVal', newVal, oldVal);
        if(newVal>0){
          this.init(newVal);
        }
      },
      immediate: true
    },

    'invoiceTask.task.i3': {
      handler(newVal, oldVal) {
        // console.log(newVal, oldVal);
        if (newVal !== oldVal) {
          // console.log(newVal, oldVal);
          this.onInvoiceTypeChange(newVal);
        }
      },
      immediate: false
    },
    'invoiceTask.task.st2': {
      handler(newVal, oldVal) {
        if (newVal !== oldVal) {
          this.onInvoiceSt2Change(newVal);
        }
      },
      immediate: false
    }
  },
  methods: {
    materialCloseOne(){
      let self = this;
      let boxId = this.reqDetail.b.filter((x) => x.ot == 440)[0].id;
      request({
        api: { method: "POST", url: "taskCore/CoreBoxInTaskList" },
        data: {
          id: boxId,
          skip: 0,
          size: 2000,
          model: {},
        },
        store: this.$store,
      }).then((res) => {
        if(res != false){
          const filteredTasks = res.data.tasks.filter((x) => x.locTypeId != 618138);
          let hasMissingMaterial = false;
          for(let i = 0; i < filteredTasks.length; i++){
            if(filteredTasks[i]['defaultAttachmentId'] == null){
              hasMissingMaterial = true;
              Notification.error({
                title: "Мэдэгдэл",
                message: `${filteredTasks[i]['task']} материал заавар оруулна уу.`,
                duration: 5000,
                position: "top-right",
              });
            }
          }
          if(!hasMissingMaterial){
            this.initInvoices();
            this.showModal = false;
          }
        }
      });
    },
    taskPosted(e){
      this.$refs[`ldr_box_${e.prms.boxId}`][0].reInit();
      this.editClosed();
    },
    taskDeleted() {
      this.$refs[`ldr_box_${this.taskDialogSide.boxId}`][0].reInit();
      this.editClosed();
    },
    taskUpdated() {
      this.taskDialogSide.id = 0;
      this.$refs[`ldr_box_${this.taskDialogSide.boxId}`][0].reInit();
    },
    editClosed() {
      this.taskEdit.render = false;
      this.taskEdit.show = false;
      this.taskEdit.id = 0;
    },
    openAdd(b) {
      //console.log(b);
      this.taskEdit.id = 0;
      this.taskEdit.boxId = b.id;
      this.taskEdit.objectTypeId = b.ot;
      this.taskEdit.projectId = b.projectId;
      this.taskEdit.parentId = this.profile.id;
      this.taskEdit.render = true;
      this.$nextTick(function() {
        this.taskEdit.show = true;
      });
    },
    showFile(e) {
      console.log('showFile', e);
      // this.fileDialog.id = parseInt(e, 10);
      // this.fileDialog.show = true;
    },
    showDetail(e) {
      //console.log('showDetail', e);
      this.taskDialogSide.boxId = e.boxId;
      this.taskDialogSide.id = e.id;
    },
    loadBoxData(e) {
      //console.log('loadBoxData', e);
    },
    boxLoaded(e) {
      if (this.profile.b.filter((x) => x.id == e.box.id).length) {
        this.profile.b.filter((x) => x.id == e.box.id)[0]["taskCount"] =
          e.allCount;
      }
    },
    getCls(b) {
      let rv;
      if (b.minRequiredObjectCount > 0) {
        if (b.minRequiredObjectCount <= b.taskCount) {
          rv = "bd-success";
        } else {
          rv = "bd-danger";
        }
      } else if (b.taskCount > 0) {
        rv = "bd-success";
      }
      return rv;
    },
    fetchExamRs(){
      request({
        api: { method: "GET", url: "type/getData" },
        params:{
          key: 'tmzExamLevel'
        },
        store: this.$store,
      }).then((res) => {
        if (res != false) {
          this.examRs= res.data.types;

          // console.log('this.examRs', this.$route.params);
          // if(this.$store.state.app.activeGroup.id == 9379
          // && this.$route.name=== 'lmsExamr'
          // // && this.$route.params.mode == 1
          // ){
          //   console.log('this.examRs', this.$route.params);
          // }
        }
      });
    },
    onInvoiceTypeChange(newVal) {
      if (newVal === 1) {
        // Organization type selected
        this.invoiceTask.task.task = '';
        this.invoiceTask.task.st2 = '';
      } else if (newVal === 2) {
        // console.log('Individual type selected', this.$store.state.user.userInfo.fullName);
        // Individual type selected
        this.invoiceTask.task.task = this.$store.state.user.userInfo.fullName;
        this.invoiceTask.task.st2 = this.$store.state.user.userInfo.register;
      }
    },
    onInvoiceSt2Change(newVal) {
      // Check if i3 is 1 and st2 has more than 3 characters
      if (this.invoiceTask.task.i3 === 1 && newVal && newVal.length > 3) {
        this.onOrganizationRegisterChange(newVal);
      }
    },
    onOrganizationRegisterChange(registerValue) {
      this.toggleBodyClass("addClass", "dynamic-locker");
      request({
        api: { method: "GET", url: "CRM/GetOrganizationNameByRegister" },
        params: { regNo: registerValue },
      }).then((res) => {
        this.toggleBodyClass("removeClass", "dynamic-locker");
        if(res != false && res?.data?.found===true){
          // console.log(res);
          this.invoiceTask.task.task = res.data.name;
        }else{
          this.invoiceTask.task.task = '';
        }
      });
    },
    onLastExams(e){

      let hdetmp = getConfigValueByKey(
        this.$store.state.app.groupSettings,
        "onlineExamRegistration_passPerc"
      );
      let passperc = 0;
      if (hdetmp != undefined) {
        passperc = parseInt(hdetmp, 10);
      }

      this.lastExams = e;
      // console.log(this.lessons, this.lastExams);
      this.lessons.forEach(l=>{
        this.lastExams.filter(e=>e.perc >= passperc).forEach(e=>{
          if(l.locTypeId == e.locTypeId){
            l.locked = true;
          }
        });
      });
    },
    downloadAttachment(e) {
      request({
        api: { method: "get", url: "Media/FileInheritedDetail" },
        params: { id: e },
        store: this.$store,
      }).then((res) => {
        window.open(res.data.file.link);
      });
    },
    materialStep() {
      this.step = 3;
    },
    materialTasksLoaded(e) {
      e = e.tasks;
      if (this.$store.state.user.userInfo.groupId == 6126) {
        let allHaveAttachesCount = e.filter(
          (x) => x.defaultAttachmentId != null
        ).length;
        let allMaterialsCount = e.length;

        if (this.profileModel.i1 == 1) {
          if (allHaveAttachesCount == allMaterialsCount)
            this.materialFull = true;
          else this.materialFull = false;
        } else {
          let notMmnbiAll = e.filter((x) => x.taskEn != "mmnbi").length;
          let notMmnbiAttachesCount = e.filter(
            (x) => x.taskEn != "mmnbi" && x.defaultAttachmentId != null
          ).length;
          if (notMmnbiAttachesCount == notMmnbiAll) {
            this.materialFull = true;
          } else {
            this.materialFull = false;
          }
        }
      } else if (this.$store.state.user.userInfo.groupId == 9157) {
        this.materialFull = true;
      } else {
        let allHaveAttachesCount = e.filter(
          (x) => x.defaultAttachmentId != null
        ).length;
        let allMaterialsCount = e.length;
        if (allHaveAttachesCount == allMaterialsCount) this.materialFull = true;
      }
    },
    fetchInvoice(){
      this.toggleBodyClass("addClass", "dynamic-locker");
      request({
        api: { method: "GET", url: "Payment/GetInvoiceDetail" },
        params: { id: this.reqDetail.id },
      }).then((res) => {
        this.toggleBodyClass("removeClass", "dynamic-locker");
        if(res!=false){
          this.invoiceTask = res.data.invoice;
        }
      });
    },
    updateInvoiceInfo() {
      this.toggleBodyClass("addClass", "dynamic-locker");
      request({
        api: { method: "post", url: "Payment/updateInvoiceInfo" },
        data: {
          id: this.reqDetail.id,
          i3: this.invoiceTask.task.i3,
          task: this.invoiceTask.task.task,
          st2: this.invoiceTask.task.st2,
        },
        store: this.$store,
      }).then((res) => {
        this.toggleBodyClass("removeClass", "dynamic-locker");
        if (res != false) {
          this.step++;
        }
      });
    },
    initInvoices() {
      request({
        api: { url: "Payment/GetMyInvoices", method: "get" },
        store: this.$store,
      }).then((res) => {
        // console.log('Payment/GetMyInvoices', res);
        this.invoices = res.data.tasks.filter(
          (x) =>
            x.thirdOrganizationTask != null &&
            x.thirdOrganizationTask.objectTypeId == 340
        );
      });
    },
    initFiles() {
      this.fileDownloads = this.$store.state.app.groupSettings.filter((x) =>
        x.key.includes("file_exam")
      );
      // console.log('initFiles', this.fileDownloads);
    },
    fromInvoice(e) {
      this.invoices = e;
    },
    showPrint(i) {
      this.$refs.btnLearnExamInvoiceAccept[i].init();
    },
    reInit() {
      this.init();
    },
    ssChanged(e) {
      this.submitModel.taskEn = this.ssList.filter((f) => f.id == e)[0].task;
    },
    toggleBodyClass(addRemoveClass, className) {
      const el = document.body;
      if (addRemoveClass === "addClass") {
        el.classList.add(className);
      } else {
        el.classList.remove(className);
      }
    },
    init(ltype) {
      let _flag1 = -1;
      if (this.$store.state.user.userInfo.locType4Code == "member") {
        _flag1 = 2;
      } else if (this.$store.state.user.userInfo.locType4Code == "register") {
        _flag1 = 3;
      } else if (this.$store.state.user.userInfo.locType4Code == "learning") {
        _flag1 = 5;
      }
      // console.log('init', _flag1);
      switch (_flag1) {
        case 2:
        case 3:
        case 5:
          request({
            api: {
              url: "learn/GetFutureOnlineExamRegisterList",
              method: "get",
            },
            params: {
              flag1: _flag1,
            },
            store: this.$store,
          }).then((res) => {
            this.list = res.data.tasks;

            if(ltype){
              this.list = this.list.filter(e=> e.locTypeId==ltype);
            }

            if(this.$store.state.user.userInfo?.memberLicInfo?.ord > 0){
              this.list = this.list.filter(e=>e.locTypeOrd === this.$store.state.user.userInfo.memberLicInfo.ord+10);
            }else {
              this.list = this.list.filter(e=>e.locTypeOrd === 10);
            }
            // this.list = res.data.tasks;
            // console.log('init', ltype, this.list, res);
          }); 
          break;
        default:
          break;
      }
    },
    payInvoice() {
      this.$refs.gopymnt.doPayment(this.reqDetail.id);
    },
    backToProfile(tsk){
      request({
        api: { method: "GET", url: "task/taskInheritedDetail" },
        params: { id: tsk.id },
        store: this.$store,
      }).then((res) => {
        this.sendRequestBefore(res.data.task);
        this.step = 1;
      });
    },
    sendRequestBefore(task){
      let _pid = 0;
      let prj = this.$store.state.app.groupDefaultProjects.filter(
        (x) => x.objectTypeId == parseInt(138, 10)
      );
      if (prj.length > 0) _pid = prj[0].id;
      request({
        api: { method: "GET", url: "Task/GetInherited" },
        params: {
          id: this.$store.state.user.userInfo.profileId,
          objectTypeId: 138,
          parentId: 0,
          projectId: _pid,
          boxId: 0,
          userId: this.$store.state.user.userInfo.userId,
        },
        store: this.$store,
      }).then((res) => {
        this.profile = res.data.task;
        request({
          api: { method: "GET", url: "task/taskInheritedDetail" },
          params: { id: this.profile.id },
          store: this.$store,
        }).then((res) => {
          this.profile = res.data.task;

          // this.avatar.uploadedUrl = this.$store.state.user.userInfo.avator;


          if(this.$store.state.app.activeGroup.id == 9379){
            // this.profile.b.filter(x => x.ot == 139)[0]["nm"] = "Эзэмшсэн мэргэжил";
          }
          this.profile.b = this.profile.b.filter(
              (x) =>
                x.ot == 139 || 
                x.ot == 140 || 
                x.ot == 149 || 
                x.ot == 377  
                || x.ot == 651 || x.ot == 652
            );
        });
      });
      this.sendRequest(task);
    },
    sendRequest(task) {
      this.ilgeejbuibvrtgel= task;
      if (task.id == 915570) {
        this.$Notice.info({
          title: "Мэдэгдэл",
          desc: "Шалгалтын бүртгэл хаагдсан.",
          duration: 60,
        });
      } else if (task.id == 915364) {
        this.$Notice.info({
          title: "Мэдэгдэл",
          desc:
            "Шалгалтын бүртгэл 2020-06-12 ны өдрийн 12:00 цагт бүртгэл хаагдав.",
          duration: 60,
        });
      } else {
        this.step = 1;
        this.toggleBodyClass("addClass", "dynamic-locker");
        request({
          api: {
            url: "task/taskInheritedDetail",
            method: "get",
          },
          params: { id: task.id, requestFlag: 293 },
          store: this.$store,
        }).then((res) => {
          this.task = task;
          this.courseDetail = res.data.task;
          let invoiceBoxId = 0;
          if (this.courseDetail.b.filter((x) => x.ot == 343).length > 0) {
            invoiceBoxId = this.courseDetail.b.filter((x) => x.ot == 343)[0].id;
          }

          let _projid = 0;
          if (
            this.$store.state.app.groupDefaultProjects.filter(
              (x) => x.objectTypeId == 343
            ).length > 0
          ) {
            _projid = this.$store.state.app.groupDefaultProjects.filter(
              (x) => x.objectTypeId == 343
            )[0].id;
          }
          request({
            api: {
              url: "task/GetInherited",
              method: "get",
            },
            params: {
              id: 0,
              projectId: _projid,
              parentId: 0,
              boxId: invoiceBoxId,
              objectTypeId: 343,
              userId: this.$store.state.user.userId,
            },
            store: this.$store,
          }).then((res) => {
            if (res != false) {
              this.submitModel = res.data.task;
              request({
                api: {
                  url: "task/GetInherited",
                  method: "get",
                },
                params: {
                  id: this.$store.state.user.userInfo.profileId,
                },
                store: this.$store,
              }).then((resProfile) => {
                if (resProfile != false) {
                  this.profileModel = resProfile.data.task;
                  this.profileModel.i3 = 1;
                  this.submitModel.taskDesc =
                    this.courseDetail.task +
                    " төлбөр. Овог: " +
                    this.profileModel.lat +
                    " Нэр: " +
                    this.profileModel.task +
                    " Регистр: " +
                    this.profileModel.langCode;
                }
              });

              this.toggleBodyClass("removeClass", "dynamic-locker");

              this.submitModel.taskEn = "";
              this.submitModel.task = "";
              this.submitModel.thirdOrganizationTaskId = task.id;

              this.submitModel.budget = this.ilgeejbuibvrtgel.budget;

              if (this.submitModel.isTender == null)
                this.submitModel.isTender = false;
              if (this.submitModel.isRepeat == null)
                this.submitModel.isRepeat = false;
              request({
                api: {
                  url: "task/boxInTaskList",
                  method: "get",
                },
                params: {
                  id: this.courseDetail.b.filter((x) => x.ot == 341)[0].id,
                  page: 0,
                  size: 100,
                },
                store: this.$store,
              }).then((res) => {
                this.lessons = res.data.tasks.filter((x) => x.isTender);
                this.showModal = true;
              });
            }
          });
        });
      }
    },
    hideModal() {
      if (this.step == 1) {
        this.task = {};
        this.showModal = false;
      }
      this.step--;
    },
    updateProfileInfo() {
      this.toggleBodyClass("addClass", "dynamic-locker");
      request({
        api: { url: "Task/PostInherited", method: "post" },
        data: { model: this.profile },
        store: this.$store,
      }).then((res) => {
        this.toggleBodyClass("removeClass", "dynamic-locker");
        if(res != false){
          this.step++;
        }
      });
    },
    SubmitRequest() {
      if(this.step == 1){
        this.updateProfileInfo();
        return;
      }
      let lids = this.lessons
        .filter((l) => l.selcd == true && l.locTypeCode == "chosen")
        .map(function(e) {
          return e.id;
        });

      let lidsSend = this.lessons
        .filter((l) => l.selcd == true)
        .map(function(e) {
          return e.id;
        });

      let errs = [];

      // if (
      //   (this.$store.state.user.userInfo.groupId == 6126 ||
      //     this.$store.state.user.userInfo.groupId == 9157) &&
      //   this.step == 2
      // ) {
      //   if (lidsSend.length == 0) {
      //     errs.push("Шалгалт сонгоогүй байна");
      //   }
      // }

      if (this.submitModel.task == "" && this.step == 2) {
        errs.push("Хүсэлт оруулна уу !");
      }

      // if (!this.submitModel.isRepeat && this.step == 1) {
      //   errs.push("Гэрээг зөвшөөрөөгүй байна !");
      // }

      // if ((this.$store.state.user.userInfo.groupId == 9157 || this.$store.state.user.userInfo.groupId == 6126) && this.step == 1) {
      //   if (this.submitModel.locTypeId4 <= 0) {
      //     errs.push("Таны ажиллаж амьдарч буй байршил");
      //   }
      // }

      if (this.step == this.stepPost) {
        var biPostoljChadahuu = false;
        if (this.ssList.length > 0) {
          if (this.submitModel.taskEn.length > 0) {
            biPostoljChadahuu = true;
          } else {
            biPostoljChadahuu = false;
          }
        } else {
          biPostoljChadahuu = true;
        }

        if (errs.length == 0) {
          if (biPostoljChadahuu) {
            this.toggleBodyClass("addClass", "dynamic-locker");
            if (this.submitModel.isRepeat) {
              if (this.submitModel.task == "") {
                this.toggleBodyClass("removeClass", "dynamic-locker");
                Message.error("Ажлын газар оруулна уу.");
              } else {
                this.toggleBodyClass("addClass", "dynamic-locker");
                request({
                  api: { url: "Task/PostInherited", method: "post" },
                  data: { model: this.profileModel },
                  store: this.$store,
                });

                this.submitModel.parentId = 0;
                request({
                  api: { url: "Task/PostInherited", method: "post" },
                  data: { model: this.submitModel },
                  store: this.$store,
                }).then((resInv) => {
                  if (resInv.result == 1) {
                    this.toggleBodyClass("removeClass", "dynamic-locker");
                    //console.log("beforeeeee task share", this.task.id);
                    request({
                      api: {
                        url: "TaskInUser/shareUserToTask",
                        method: "post",
                      },
                      data: {
                        taskId: this.task.id,
                        userId: this.$store.state.user.userId,
                      },
                      store: this.$store,
                    });

                    this.task = {};
                    this.toggleBodyClass("addClass", "dynamic-locker");
                    request({
                      api: {
                        url: "Payment/PostProductAndWorkservice",
                        method: "post",
                      },
                      data: { invoiceId: resInv.taskId, workIds: lidsSend },
                      store: this.$store,
                    }).then((resWork) => {
                      this.toggleBodyClass("removeClass", "dynamic-locker");
                      if (resWork != false) {
                        if (resWork.data.result == 1) {
                          // console.log('resWork', resInv, resWork);
                          this.continueExamRegistration({ id: resInv.taskId });

                          this.$emit("on-inf-fetch");
                          this.init();
                        } else if (resWork.data.result == 0) {
                          this.init();
                        } else {
                          this.$Notice.error({
                            title: "Алдаа",
                            desc:
                              "Байгууллага хариуцсан мэргэжилтэнд хандана уу. ",
                            duration: 60,
                          });
                        }

                        this.initInvoices();
                        this.$emit("reload-exam-registration");
                      }
                    });
                  } else {
                    this.toggleBodyClass("removeClass", "dynamic-locker");
                  }
                });
              }
            } else {
              this.toggleBodyClass("removeClass", "dynamic-locker");
              Message.error("Мэдээлэл үнэ болохыг зөвшөөрөөгүй байна !");
            }
          } else {
            this.toggleBodyClass("removeClass", "dynamic-locker");
            Message.error("Судалгааны сэдэв бичнэ үү !");
          }
        } else {
          Message.error(errs[0]);
        }
      } else {
        if (
          this.lessons.filter((l) => l.locTypeCode == "chosen").length > 0 &&
          this.lessons.filter((l) => l.locTypeCode == "chosen").length < 5
        ) {
          if (lids.length == 0 && this.step == 1) {
            Message.error("Хичээл сонгоогүй байна !");
          } else {
            this.step++;
          }
        } else if (
          this.lessons.filter((l) => l.locTypeCode == "chosen").length >= 5
        ) {
          if (lids.length < 2 && this.step == 1) {
            Message.error(
              "Та тасралтгүй боловсрол олгох хичээлээс 2-оос доошгүй кредит цагийн хичээл судалсан байна"
            );
          } else {
            this.step++;
          }
        } else if (errs.length > 0) {
          Message.error(errs[0]);
        } else {
          if (this.step == 3) {
            if (this.materialFull) {
              this.updateExamInvoice();
            } else {
              Message.error("Бүрдүүлэх материал дутуу байна");
            }
          } else {
            this.step++;
          }
        }
      }
    },
    cascaderOnChange(value, selectedData) {},
    getConfigValueByKey(key) {
      return getConfigValueByKey(this.$store.state.app.groupSettings, key);
    },
    onAttach(e) {
      this.modalGeree.show = true;
      this.modalGeree.id = e;
      this.modalGeree.rdy = true;
    },
    readGeree() {
      let _id = this.getConfigValueByKey("learnCourseAgreement");
      if (
        this.$store.state.user.userInfo.groupId == 9157 ||
        this.$store.state.user.userInfo.groupId == 6126 ||
        this.$store.state.user.userInfo.groupId == 1104
      ) {
        _id = this.getConfigValueByKey("learnExamAgreement");
      }
      this.modalGeree.show = true;
      this.modalGeree.id = parseInt(_id, 10);
      this.modalGeree.rdy = true;
    },
    readTurGorim() {
      this.modalGeree.show = true;
      this.modalGeree.id = 525871;
      this.modalGeree.rdy = true;
    },

    paymntCancel(e) {
      if (!e) {
        this.payInvoiceId = 0;
        this.paymentVisible = false;
        this.$refs.gopymnt.paymentCheckCount = 100;
      }
    },
    continueExamRegistration(inv, i) {

      if (inv.thirdOrganizationTask != undefined) {
        request({
          api: { url: "TaskInUser/GetSharedUserInfo", method: "get" },
          params: {
            trackUserId: this.$store.state.user.userId,
            taskId: inv.thirdOrganizationTask.id,
          },
          store: this.$store,
        }).then((res) => {
          if (res.data.user.colorCls != null && res.data.user.colorCls != "") {
            //this.showPrint(i);
            // console.log('this.$route.name', inv);
            if(this.$route.name === 'lmsParticipant'){
              // console.log('res', res, this.$route);  
              this.$router.push({
                name: 'lmsExamr',
                params: {
                  mode: 1,
                  id: inv?.thirdOrganizationTask?.locTypeId,
                },
              });
            }
            Message.success("Таны бүртгэл баталгаажсан байна.");
          } else {
            this.continueExamRegistrationAfter(inv);
          }
        });
      } else {
        this.continueExamRegistrationAfter(inv, 1);
      }
    },
    continueExamRegistrationAfter(inv, direct) {
      // console.log(inv);
      request({
        api: { method: "GET", url: "servertime" },
        store: this.$store,
      }).then((res) => {
        if (
          direct == 1 ||
          moment(res.data.now).isBefore(inv.thirdOrganizationTask.dueStartDate)
        ) {
          request({
            api: {
              url: "task/GetInherited",
              method: "get",
            },
            params: {
              id: this.$store.state.user.userInfo.profileId,
            },
            store: this.$store,
          }).then((resProfile) => {
            if (resProfile != false) {
              this.profileModel = resProfile.data.task;
            }
          });
          request({
            api: {
              url: "task/taskInheritedDetail",
              method: "get",
            },
            params: {
              id: inv.id,
            },
            store: this.$store,
          }).then((res) => {
            if (res != false) {
              this.reqDetail = res.data.task;
              // this.step = 3;

              if(this.reqDetail?.i7==1 && this.reqDetail.isTender){
                Message.info("Таны бүртгэл баталгаажсан байна.");
                return;
              } else if(this.reqDetail?.i7==1 && !this.reqDetail.isTender){
                this.step = 4;
              }else{
                this.step = 3;
              }
              
              // console.log('inv?.thirdOrganizationTask?.locTypeValue', inv?.thirdOrganizationTask?.locTypeValue, inv);
              // if(inv?.thirdOrganizationTask?.locTypeValue == "olgoh" || this.ilgeejbuibvrtgel.locTypeValue==='olgoh'){
              //   this.step = 3;
              // } else {
              //   this.step = 4;
              // }
              this.showModal = true;
            }
          });
        } else {
          Message.info("Бүртгэл хаагдсан байна.");
        }
      });
      //console.log(inv);
    },
    updateExamInvoice() {
      request({
        api: {
          url: "task/GetInherited",
          method: "get",
        },
        params: {
          id: this.reqDetail.id,
        },
        store: this.$store,
      }).then((res) => {
        var _model = res.data.task;
        _model["i7"] = 1;
        request({
          api: { url: "Task/PostInherited", method: "post" },
          data: { model: _model },
          store: this.$store,
        }).then((res) => {
          if (res.result == 1) {
            this.step++;
            this.fetchInvoice();
            this.initInvoices();
          }
        });
      });
    },
    displayStatus(inv, mode) {
      // console.log('inv', inv, mode);
      let rv = "";
      if (mode == 0) {
        if (inv.i8 == 1) {
          rv = "Баталгаажсан";
        } else if (inv.i7 == 2) {
          rv = `Буцаагдсан - ${inv.s11}`;
        } else if (inv.i7 != 1) {
          if(inv.box440TaskHasAttachCount>=inv.box440TaskCount){
            rv = "Хүсэлт илгээгдсэн. Таны бүртгэлийг админ баталгаажуулснаар төлбөр төлөх боломжтой.";
          }else{
            rv = "Хүсэлт илгээгдсэн. Таны бүртгэлийг админ баталгаажуулснаар төлбөр төлөх боломжтой.";
            // rv = `Материал дутуу (${inv.box440TaskHasAttachCount}/${inv.box440TaskCount}) оруулсан тул гүйцээж оруулна уу`;
          }
        } else if (inv.i7 == 1 && !inv.isTender) {
          rv = "Таны хүсэлт баталгаажсан тул энд дарж төлбөр төлнө үү. ";
        } else if (inv.i7 == 1 && inv.isTender) {
          rv = "Баталгаажсан";
        } else {
          rv = "Хүлээгдэж буй";
        }
      } else if (mode == 1) {
        if (inv.i8 == 1) {
          rv = "#10b759";
        } else if (inv.i7 != 1) {
          rv = "#dc3545";
        } else if (inv.i7 == 1 && !inv.isTender) {
          rv = "#ffc107";
        } else {
          rv = "#00b8d4";
        }
      }
      return rv;
    },
    reSendReq(){
      let self = this;
      let boxId = this.reqDetail.b.filter((x) => x.ot == 440)[0].id;
      request({
        api: { method: "POST", url: "taskCore/CoreBoxInTaskList" },
        data: {
          id: boxId,
          skip: 0,
          size: 2000,
          model: {},
        },
        store: this.$store,
      }).then((res) => {
        if(res != false){
          const filteredTasks = res.data.tasks.filter((x) => x.locTypeId != 618138);
          let hasMissingMaterial = false;
          for(let i = 0; i < filteredTasks.length; i++){
            if(filteredTasks[i]['defaultAttachmentId'] == null){
              hasMissingMaterial = true;
              Notification.error({
                title: "Мэдэгдэл",
                message: `${filteredTasks[i]['task']} материал заавар оруулна уу.`,
                duration: 5000,
                position: "top-right",
              });
            }
          }
          if(!hasMissingMaterial){
            this.reSendReqAfter();
          }
        }
      });
    },
    reSendReqAfter(){
      let _model={};
      request({
        api: { method: "GET", url: "task/taskInheritedDetail" },
        params: { id: this.reqDetail.id },
        store: this.$store,
      }).then((res) => {
          if(res != false){
              _model = res.data.task;
              _model.i7= 0;
              _model.s11= '';

              request({
                  api: { method: "POST", url: "Task/PostInherited" },
                  data: { model: _model },
                  store: this.$store
              }).then(res => {
                  this.showModal = false;
                  this.initInvoices();
                  Message.info("Дахин илгээгдлээ.");
              });
          }
      });
    },

  },
};
</script>
